module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAyBAMAAADy2KUxAAAAGFBMVEVQ0sL+///p+fd63dDN8u2d5dxm2Mq77ed+toh3AAAAVElEQVQ4y2NgGAXDGxg54JNlU1TAJ80kaIBP2lEYnyy7YAA+6UBxfLKsgnjdbSiE31dqFPiKgDQBwwk4jZDHCAQLoUAlECUMSYT8pkBBYhoFQxwAALLTBvOrBONMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-arrow-left.png
// module id = 432
// module chunks = 2